import React, { useMemo } from 'react'
import './hero.css'
import HeroCarousel, { mergeHeroSlidesFromApi } from '../HeroCarousel'
import { Link } from 'react-router-dom'
import { HERO_CTA_LABEL, HERO_DESCRIPTION, HERO_EYEBROW, HERO_HEADLINE } from '../../constants/brand'

const Hero = ({ homePageMedia }) => {
  const slides = useMemo(
    () => mergeHeroSlidesFromApi(homePageMedia?.hero_slides),
    [homePageMedia],
  )

  return (
    <section className="hero">
      <div className="hero-content">
        <span className="eyebrow">{HERO_EYEBROW}</span>
        <h1>{HERO_HEADLINE}</h1>
        <p>{HERO_DESCRIPTION}</p>
        <Link to="/rooms">
          <button type="button">{HERO_CTA_LABEL}</button>
        </Link>
      </div>
      <div className="hero-image">
        <HeroCarousel slides={slides} />
      </div>
    </section>
  )
}

export default Hero